import { render, staticRenderFns } from "./CheckoutRegisterKidStep.vue?vue&type=template&id=2e8f2cfb&scoped=true"
import script from "./CheckoutRegisterKidStep.vue?vue&type=script&lang=js"
export * from "./CheckoutRegisterKidStep.vue?vue&type=script&lang=js"
import style0 from "./CheckoutRegisterKidStep.vue?vue&type=style&index=0&id=2e8f2cfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f2cfb",
  null
  
)

export default component.exports